const Schema = () => ({
  label: 'Video Slider',
  category: 'Slider',
  key: 'videoSlider',
  previewSrc:
    'https://cdn.shopify.com/s/files/1/1011/0318/files/What_is_Testing_d2572378-3760-4039-96e2-5be32928fad4.jpg?v=1752878794',
  fields: [
    {
      label: 'Heading',
      name: 'heading',
      component: 'text',
      defaultValue: 'What others are saying',
    },
    {
      label: 'Video Slides',
      name: 'videoSlides',
      component: 'group-list',
      description:
        'We recommend adding at a minimum 10 slides to ensure proper looping.',
      itemProps: {
        label: '{{item.title}}',
      },
      fields: [
        {
          label: 'Title',
          name: 'title',
          component: 'text',
        },
        {
          label: 'Video URL',
          name: 'videoUrl',
          component: 'text',
        },
        {
          label: 'Poster Image',
          name: 'videoPoster',
          component: 'image',
          description: 'First frame of video while video loads',
        },
        {
          name: 'product',
          label: 'Product',
          component: 'productSearch',
        },
        {
          label: 'Override Product Image',
          name: 'productImage',
          component: 'image',
          description: 'Use this image instead of the products default first image',
        },
        {
          label: 'Override Product Image Alt Text',
          name: 'productImageAlt',
          component: 'text',
        },
      ],
    },
  ],
});

export default Schema;
